import React, { useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { getTwitchOAuth, validationDataSelector } from 'src/store/auth';

import { ROUTE } from 'src/constants/routes';
import { CustomButton } from 'src/components';
import { LanguageSwitcher } from '../LanguageSwitcher/LanguageSwitcher';

import { TwitchOutlined } from '@ant-design/icons';
// import Logo from 'src/assets/logo.webp';
import { Logo192 } from 'src/assets';
import './footer.scss';

export const Footer = () => {
  const { t } = useTranslation('footer');

  const dispatch = useDispatch();
  const { pathname } = useLocation();

  const validationData = useSelector(validationDataSelector);
  const quickLinks = t('links', { returnObjects: true });

  const hiddenButtonList = [ROUTE.AUTH.TWITCH_CALLBACK, ROUTE.DASHBOARD.MAIN];
  const isVisibleButton = !hiddenButtonList.includes(pathname);

  const onClickConnect = useCallback(() => {
    dispatch(getTwitchOAuth());
  }, [dispatch]);

  return (
    <footer className="landing-footer">
      <div className="landing-footer__content">
        <div className="landing-footer__brand">
          <div className="header__logo" style={{ maxWidth: '90px' }}>
            {/* <img src={Logo} alt={Logo} width={200} /> */}
            <img className="ant-layout__logo" src={Logo192} alt="Logo" />
            <h3>BOT</h3>
          </div>

          <p className="landing-footer__description">{t('description')}</p>
        </div>

        <div className="landing-footer__links">
          <p className="landing-footer__label">{t('explore')}</p>
          <nav className="landing-footer__nav">
            {quickLinks.map((link) => (
              <Link key={link.label} className="landing-footer__nav-link" href={link.href}>
                {link.label}
              </Link>
            ))}
          </nav>
        </div>

        <div className="landing-footer__cta">
          <p className="landing-footer__label">{t('get_started')}</p>
          <LanguageSwitcher className="landing-footer__language-switcher" />

          {isVisibleButton && !validationData?.status ? (
            <CustomButton
              title={t('login_cta')}
              onClick={onClickConnect}
              icon={TwitchOutlined}
              iconPosition="right"
            />
          ) : null}

          {/* USER LOGED IN STATE */}
          {isVisibleButton && validationData?.status ? (
            <CustomButton
              title={t('header:dashboard')}
              component="link"
              to={ROUTE.DASHBOARD.MAIN}
            />
          ) : null}

          {/* USER IN DASHBOARD */}
        </div>
      </div>
    </footer>
  );
};
